export interface Bonus {
  number: string;
  title: string;
  price: string;
  body: string;
  imageAlt: string;
}

export const bonuses: Bonus[] = [
  {
    number: 'BONUS 01',
    title: 'The Inspection-Ready Binder',
    price: '$67',
    body:
      'A pre-labeled tab structure plus the eleven documents licensors ask for most often. Print it, fill it, and hand over one binder instead of digging through a drawer.',
    imageAlt: 'Tabbed compliance binder standing open on a desk, labels facing forward',
  },
  {
    number: 'BONUS 02',
    title: 'The Tuition Recovery Letter Pack',
    price: '$59',
    body:
      'Eleven letters and texts, escalating from a friendly reminder to a final notice — the exact wording that collects late tuition without ending the relationship.',
    imageAlt: 'Stack of printed letter templates with a brass paperclip',
  },
  {
    number: 'BONUS 03',
    title: 'The Parent Handbook Template',
    price: '$49',
    body:
      'A complete, editable handbook covering hours, illness, late pickup, screen time, discipline and holidays. Replace the bracketed fields and it is yours.',
    imageAlt: 'Printed parent handbook lying flat, cover page visible',
  },
  {
    number: 'BONUS 04',
    title: 'The Ratio & Schedule Calculator Sheets',
    price: '$47',
    body:
      'Print-and-write sheets that tell you at a glance whether tomorrow is legal, staffed and profitable — before you accept the enrollment.',
    imageAlt: 'Ruled ledger sheet with penciled ratio calculations',
  },
  {
    number: 'BONUS 05',
    title: 'The Rate Increase Script Library',
    price: '$42',
    body:
      'The letter, the follow-up, and the four objections you will hear — with the response to each. Used by providers who have not raised rates in three years.',
    imageAlt: 'Single typed announcement letter on a clipboard',
  },
];

export const bonusesIntro = {
  badge: 'INCLUDED TODAY',
  title: 'Five working tools, not five more things to read.',
  intro:
    'The volumes explain the system. These five put it to work this week. Sold separately they total $264. Today they are included.',
};
